export default __webpack_public_path__ + "7ef4c456c9ffb8a91da9aeb682b6483b.png";